import { render, staticRenderFns } from "./maintenanceRulesList.vue?vue&type=template&id=badb4c2c&scoped=true"
import script from "./maintenanceRulesList.vue?vue&type=script&lang=js"
export * from "./maintenanceRulesList.vue?vue&type=script&lang=js"
import style0 from "./maintenanceRulesList.vue?vue&type=style&index=0&id=badb4c2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badb4c2c",
  null
  
)

export default component.exports